<template v-if="loading">
	<div v-if="openCompanyModal">
		<modal>
			<template slot="header">
				<md-button class="md-simple md-just-icon md-round modal-default-button" @click="closeSelectionModal">
					<md-icon>clear</md-icon>
				</md-button>
				<p>{{ heading }}</p>
			</template>

			<template slot="body">
				<div class="company-table">
					<md-table :value="queriedData" md-card @md-selected="onSelect">
						<md-table-toolbar>
							<div class="filter-section">
								<md-field style="width: 50px">
									<label for="pages">Per page</label>
									<md-select v-model="pagination.perPage" name="pages">
										<md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
											{{ item }}
										</md-option>
									</md-select>
								</md-field>
								<md-field style="margin: 0px 40px">
									<md-input type="search" v-model="searchQuery" clearable placeholder="Search records"></md-input>
								</md-field>
								<md-button @click="openCompanyFilter" class="md-success"> Filter</md-button>
							</div>
						</md-table-toolbar>
						<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single" md-auto-select :class="getClass(item)" style="text-align: left">
							<md-table-cell md-label="Company Name">{{ item.companyName }}</md-table-cell>
							<md-table-cell md-label="Industry">{{ item.industry }}</md-table-cell>
							<md-table-cell md-label="Sector">{{ item.sector }}</md-table-cell>
						</md-table-row>
					</md-table>
					<div class="data-footer">
						<pagination
							class="pagination-no-border pagination-success"
							v-model="pagination.currentPage"
							:per-page="pagination.perPage"
							:total="total"
							:noArrows="false"
							:pageCount="getPageCount"
						>
						</pagination>
						<div class="">
							<p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
						</div>
					</div>
				</div>
				<div v-if="this.openFilter">
					<preferred-companies-filter
						@closeFilterModal="closeFilterModal"
						@industrySelect="industrySelect"
						@sectorSelect="sectorSelect"
						:companyData="companies"
						:selectedSectorValue="filterOnSector"
						:selectedIndustryValue="filterOnIndustry"
					/>
				</div>
			</template>

			<template slot="footer">
				<div class="filter-section">
					<md-button class="md-success" @click="confirmSelection"> Confirm</md-button>
					<md-button class="md-danger" @click="cancelSelection"> Cancel</md-button>
				</div>
			</template>
		</modal>
	</div>
</template>

<script>
import { Modal } from '@/components';
import db from '@/firebase/init';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { Pagination } from '@/components';
import PreferredCompaniesFilter from '@/views/dashboard/student/preferred-companies/preferred-companies-filter.vue';
export default {
	components: {
		PreferredCompaniesFilter,
		Pagination,
		Modal,
	},
	props: {
		openCompanyModal: { type: Boolean },
		modalHeading: { type: String },
	},
	data() {
		return {
			companies: [],
			loading: false,
			filterOnIndustry: null,
			filterOnSector: null,
			searchQuery: '',
			heading: this.modalHeading,
			openModal: this.openCompanyModal,
			openFilter: false,
			selected: null,
			isSelected: false,
			rowsPerPage: 5,
			pagination: {
				perPage: 10,
				currentPage: 1,
				perPageOptions: [10, 15, 20, 25, 50, 100],
				total: 0,
			},
			newData: null,
		};
	},
	computed: {
		getPageCount() {
			return Math.ceil(this.total / this.pagination.perPage);
		},
		getSectorFilter() {
			return this.filterOnSector;
		},
		getIndustryFilter() {
			return this.filterOnIndustry;
		},
		queriedData() {
			let result = this.companies;

			if (this.searchQuery.length > 0) {
				const keyword = this.searchQuery.toLowerCase();
				result = result.filter(company => {
					const { companyName, industry, sector } = company;
					return [companyName, industry, sector].some(element => element.toLowerCase().includes(keyword));
				});
			}

			if (this.getSectorFilter != null || this.getIndustryFilter != null) {
				result = result.filter(company => {
					const sectorMatch = this.getSectorFilter === null || this.getSectorFilter === company.sector;
					const industryMatch = this.getIndustryFilter === null || this.getIndustryFilter === company.industry;
					return sectorMatch && industryMatch;
				});
			}

			this.takeResults(result);
			return result.slice(this.from, this.to);
		},
		to() {
			let highBound = this.from + this.pagination.perPage;
			if (this.total < highBound) {
				highBound = this.total;
			}
			return highBound;
		},
		from() {
			return this.pagination.perPage * (this.pagination.currentPage - 1);
		},
		total() {
			return this.newData?.length;
		},
	},
	methods: {
		getClass(item) {
			if (this.isSelected) {
				return { 'md-primary': true };
			}
		},
		takeResults(result) {
			this.newData = result;
		},

		closeSelectionModal() {
			this.openModal = false;
			this.$emit('cancelSelection', false);
		},
		sectorSelect(value) {
			this.filterOnSector = value;
		},
		industrySelect(value) {
			this.filterOnIndustry = value;
		},
		closeFilterModal(value) {
			this.openFilter = value;
			this.loading = false;
		},
		openCompanyFilter() {
			this.openFilter = true;
		},
		onSelect(item) {
			this.selected = item;
			this.isSelected = true;
		},
		confirmSelection() {
			this.$emit('companySelection', this.selected);
		},
		cancelSelection() {
			this.selected = null;
			this.$emit('cancelSelection', false);
		},
	},
	async created() {
		const snapshot = await db.collection('Settings').doc('Preferred Employers').get();
		this.companies = snapshot.data().companies;
		this.loading = true;
	},
};
</script>

<style scoped>
.data-footer {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: baseline;
	margin: 0px 20px;
}

.filter-section {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	margin-top: 20px;
}
</style>
